import { BooleanField, DateField, ResourceProps, Show, Tab, TabbedShowLayout, TextField } from 'react-admin';

import { FC } from 'react';

const ComplaintsShow: FC<ResourceProps> = (props) => {
  return (
    <Show title="Жалоба" {...props}>
      <TabbedShowLayout>
        <Tab label="О жалобе">
          <TextField source="id" />
          <TextField label="Причина" source="reason" />
          <DateField locales="rus" label="Создано" source="createdAt" />
          <DateField locales="rus" label="Обновлено" source="updatedAt" />
          <BooleanField source="checked" />
        </Tab>
        <Tab label="От кого">
          <TextField label="Nickname" source="fromUser.nickname" />
          <TextField label="ID" source="fromUser.id" />
          <BooleanField label="Заблокирован" source="fromUser.isBlocked" />
        </Tab>
        <Tab label="На кого">
          <TextField label="Nickname" source="toUser.nickname" />
          <TextField label="ID" source="toUser.id" />
          <BooleanField label="Заблокирован" source="toUser.isBlocked" />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default ComplaintsShow;
